import { RSAA } from 'redux-api-middleware';
import * as types from "../types/index";
import { API_ENDPOINT, AUTH_HEADERS } from '../../config/ApiConstants';


export function taxonomyDataAPI_Action(token, organisationId, groupId, taxonomyId) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/organisation/group/${groupId}/taxonomy/${taxonomyId}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                'Authorization': 'Bearer ' + token,
                organisationId: organisationId
            },
            body: '',
            types: [
                types.TAXONOMY_DATA_REQUEST,
                types.TAXONOMY_DATA_RECEIVE, {
                    type: types.TAXONOMY_DATA_FAILURE,
                    meta: (action, state, res) => {
                        return (action, state, res);
                    }
                }]
        }
    }
}

export const resetTaxonomyData_Action = () => {
    return {
        type: types.RESET_TAXONOMY_DATA,
        payload: null
    }
};
